import { httpsCallable } from 'firebase/functions'
import { getFns } from '../../../firebase'

// Server-authoritative operations only. There is deliberately no client-side
// Firestore fallback if a callable is unavailable or rejects the request.
export async function reportEnvelopeToRiss({ transactionId }) {
  const call = httpsCallable(getFns(), 'reportEnvelopeToRiss', { timeout: 300000 })
  const result = await call({ transactionId })
  return result.data
}

export async function claimReportedEnvelope({ transactionId }) {
  const call = httpsCallable(getFns(), 'claimReportedEnvelope')
  const result = await call({ transactionId })
  return result.data
}

export function envelopeActionError(error, fallback) {
  if (['functions/not-found', 'functions/unimplemented', 'functions/unavailable'].includes(error?.code)) {
    return 'The secure envelope service is not available. Ask your administrator to check that the envelope functions are deployed and available. No local status was changed; refresh before retrying.'
  }
  return error?.message || fallback
}
